module.exports = __webpack_public_path__ + "static/img/42.6b42c26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/42.png
// module id = 88ji
// module chunks = 1